<template>
  <div>
    <p v-if="caption && captionAbove" class="cg-micro mb-1">{{ caption }}</p>
    <p
      class="mb-0 cg-numeral cg-tabular"
      :class="[sizeClass, { 'text-warning-emphasis': warn }]"
    >
      {{ value
      }}<span v-if="unit" class="cg-unit text-body-secondary ms-1">{{
        unit
      }}</span>
    </p>
    <p v-if="caption && !captionAbove" class="cg-micro mb-0">
      {{ caption }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    value: string;
    unit?: string;
    caption?: string;
    size?: "md" | "lg" | "xl";
    warn?: boolean;
    /** Put the caption above the numeral (the design does this for page-level KPIs). */
    captionAbove?: boolean;
  }>(),
  { size: "md", warn: false, captionAbove: false }
);
const sizeClass = computed(
  () => ({ md: "cg-stat-md", lg: "cg-stat-lg", xl: "cg-stat-xl" })[props.size]
);
</script>

<style scoped lang="scss">
// Numerals sit on the theme's heading steps: md = h4, lg = h3, xl = h1.
.cg-stat-md {
  font-size: 1.25rem;
}
.cg-stat-lg {
  font-size: 1.5625rem;
}
.cg-stat-xl {
  font-size: 2.44140625rem;
  line-height: 1.05;
}
.cg-unit {
  font-family: var(--phoenix-font-sans-serif);
  font-weight: 400;
  font-size: 0.75rem;
}
</style>
